import React, { Component } from 'react'
import axios from 'axios'
import Layout from '../layout/Layout'
import { api } from '../utils/Api'
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom'
import Spinner from '../layout/Spinner'
import SendPayment from './SendPayment'

export default class PaymentPDF extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showModalEmail: false,
            showModalSms: false,
            pdf: '',
            loading: true,
            paymentId: this.props.location.state.paymentId,
            invoiceId: this.props.match.params.id
        }
    }

    /**
     * Get PDF invoice
     */
    getPDFInvoice = async () => {
        const url = api + `/receivepaymentpdf`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            const body = {
                invoiceId: this.state.invoiceId,
                paymentId: this.state.paymentId
            }
            const { data } = await axios.post(url, body)
            this.setState({
                pdf: data,
                loading: false
            })
        } catch (err) {
            console.error(err)
            return null
        }
    }

    /**
     * Open and close email modal
     * @param {Event} e event of the modal
     */
    toggleModalEmail = (e) => {
        this.setState({
            showModalEmail: !this.state.showModalEmail
        })
    }

    /**
     * Open and close sms modal
     * @param {Event} e event of the modal
     */
    toggleModalSms = (e) => {
        this.setState({
            showModalSms: !this.state.showModalSms
        })
    }
    
    componentDidMount() {
        this.getPDFInvoice()
    }

    render() {

        return (
            <Layout
                title='Payment PDF'
                description='Payment'
                className="container col-md-12"
            >
                <Link onClick={this.toggleModalEmail}
                    to='#'
                    className="btn btn-primary"
                >
                    Send receive by email
                </Link>                
                <Link onClick={this.toggleModalSms}
                    to='#'
                    className="btn btn-success"
                    style={{marginLeft:20}}
                >
                    Send receive by SMS
                </Link>                
                <Modal show={this.state.showModalEmail} animation={false} onHide={this.toggleModalEmail}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send Receive to:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SendPayment 
                            invoiceId={this.state.invoiceId} 
                            paymentId={this.state.paymentId}
                            pcallback={this.toggleModalEmail}
                            isEmail={true}
                        />
                    </Modal.Body>
                </Modal>  
                <Modal show={this.state.showModalSms} animation={false} onHide={this.toggleModalSms}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send Receive to:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SendPayment 
                            invoiceId={this.state.invoiceId} 
                            paymentId={this.state.paymentId}
                            pcallback={this.toggleModalSms}
                            isEmail={false}
                        />
                    </Modal.Body>
                </Modal>  
                {
                    this.state.loading ? <Spinner/> : <iframe src={this.state.pdf} width='95%' style={{height: '90vh'}} />
                }  
            </Layout>
        )
    }
}